// extracted by mini-css-extract-plugin
module.exports = {"sharedKnowledgeBase__leftSidebarHeader":"SharedKnowledgeBase_sharedKnowledgeBase__leftSidebarHeader__1w1q5"};